import _404 from "./pages/_404";
import Login from "./pages/auth/Login";
import Registration from "./pages/auth/Registration";
import ResetPassword from "./pages/auth/ResetPassword";

import AIChatBot from "./component/AIChatBot";
import Dashboard from "./pages/Dashboard";

import Profile from "./pages/Profile";
import AddParentDriver from "./pages/SchoolDashboard/parents/AddParent";
import EditParent from "./pages/SchoolDashboard/parents/EditParent";
import Vendors from "./pages/SchoolDashboard/reservation/vendor/Vendors";
import AddMaintenanceInspection from "./pages/SchoolDashboard/VehicleManagement/AddMaintenanceInspection";
import AddRouteSchedule from "./pages/SchoolDashboard/VehicleManagement/AddRouteSchedule";
import AddVehicle from "./pages/SchoolDashboard/VehicleManagement/AddVehicle";
import MaintenanceInspection from "./pages/SchoolDashboard/VehicleManagement/MaintainanceInspection";
import RouteSchedule from "./pages/SchoolDashboard/VehicleManagement/RouteSchedule";
import Settings from "./pages/Settings";
import AddSeatAvailability from "./pages/vender/AddSeatAvailability";
import SeatAvailability from "./pages/vender/SeatAvailability";
import UserCommunication from "./pages/vender/UserCommunication";

import VendorSchoolsPage from "./pages/admin/ManageVendors&Schools/Vendors-Schools";
import SchoolPage from "./pages/admin/MySchools/MySchools";
import VendorPage from "./pages/admin/MyVenders/MyVenders";
import PlansPayments from "./pages/admin/PlansPayments";
import Support from "./pages/admin/support/Support";
import SystemConfig from "./pages/admin/SystemConfig/SystemConfig";
// import SystemHealth from "./pages/admin/SystemHealth/SystemHealth";
import UserActivityLogs from "./pages/admin/UserActivityLogs";

import Color from "./pages/admin/Configuration/VehicleColor";
import Make from "./pages/admin/Configuration/VehicleMake";
import ModalPage from "./pages/admin/Configuration/VehicleModal";
import Type from "./pages/admin/Configuration/VehicleType";
import Year from "./pages/admin/Configuration/VehicleYear";
import Tracking from "./pages/admin/Tracking/tracking";
import UserForm from "./pages/admin/UserForm/UserForm";
import ParentPayment from "./pages/auth/parent-registration/PaymentForm";
import RegistrationParent from "./pages/auth/parent-registration/SignUp";
import CancelReservations from "./pages/ParentDashboard/CancelReservations";

import Reservations from "./pages/ParentDashboard/Reservations";
import RidesCompleted from "./pages/ParentDashboard/RidesCompleted";
import ParentCancellationsList from "./pages/SchoolDashboard/reservation/ParentCancellations/List";
import PaymentComplete from "./pages/PaymentComplete";
import ParentPaymentComplete from "./pages/auth/parent-registration/PaymentComplete";
import PricingPlan from "./pages/pricing-plan/PricingPlan";
import ReportingAndAnalytics from "./pages/ReportingAndAnalytics";
import PaymentHistory from "./pages/SchoolDashboard/PaymentHistory/PaymentHistory";
import ParentPaymentHistory from "./pages/SchoolDashboard/PaymentHistory/ParentPaymentHistory";
import ParentPaymentsReceived from "./pages/SchoolDashboard/PaymentHistory/ParentPaymentsReceived";
import AddRegulatoryCompliances from "./pages/SchoolDashboard/VehicleManagement/AddRegulatoryCompliance";

import SlugHandler from "./component/admin/SlugHandler";
import AddBankDetails from "./pages/admin/bank-details/AddBankDetails";
import ForgotPassword from "./pages/auth/Forgot-Password";
import OTP from "./pages/auth/OTP";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AddSchedule from "./pages/SchoolDashboard/Driver/AddSchedule";
import Schedules from "./pages/SchoolDashboard/Driver/Schedules";
import AddKids from "./pages/SchoolDashboard/parents/AddKids";
import Studenst from "./pages/SchoolDashboard/parents/Studenst";
import VendorVehicleList from "./pages/SchoolDashboard/reservation/vendor/VendorVehicleList";
import MakePayment from "./pages/ManualPayment/MakePayment";
import ManualPaymentComplete from "./pages/ManualPayment/ManualPaymentComplete";
import ManualPaymentHistory from "./pages/ManualPayment/ManualPaymentHistory";
import ReceivePayment from "./pages/ExternalCharge/ReceivePayment";
import ReceivePaymentHistory from "./pages/ExternalCharge/ReceivePaymentHistory";
import ReceivePaymentComplete from "./pages/ExternalCharge/ReceivePaymentComplete";
import AllStudents from "./pages/SchoolDashboard/parents/AllStudenst";
// ride share
import RideShareDashboard from "./pages/rideshare/RideShareDashboard";
import RideSharePlaceholder from "./pages/rideshare/RideSharePlaceholder";
import SwitchProject from "./pages/admin/SwitchProject";

export const appRoutes = [
  // ---- Public Routes ----
  { path: "/", element: <Login />, roles: null },
  { path: "/register", element: <Registration />, roles: null },
  { path: "/reset-password", element: <ResetPassword />, roles: null },
  { path: "/forgot-password", element: <ForgotPassword />, roles: null },
  // { path: "/verification", element: <Verification />, roles: null },
  { path: "/otp-verification", element: <OTP />, roles: null },
  {
    path: "/registration",
    element: <RegistrationParent />,
    roles: null,
  },
  {
    path: "/payment",
    element: <ParentPayment />,
    roles: null,
  },
  { path: "/privacy-policy", element: <PrivacyPolicy />, roles: null },
  {
    path: "/parent-payment-complete",
    element: <ParentPaymentComplete />,
    roles: null,
  },

  // ---- Dynamic/common Shared Routes ----
  {
    path: "/ask-ai",
    element: <AIChatBot />,
    roles: ["school", "vendor", "super_admin", "parent"],
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    roles: ["school", "vendor", "super_admin", "parent"],
  },

  {
    path: "/tracking",
    element: <Tracking />,
    roles: ["super_admin", "school", "vendor", "parent"],
  },
  {
    path: "/profile",
    element: <Profile />,
    roles: ["vendor", "school", "parent", "super_admin"],
  },
  {
    path: "/settings",
    element: <Settings />,
    roles: ["vendor", "school", "parent", "super_admin"],
  },
  {
    path: "/user-communication",
    element: <UserCommunication />,
    roles: ["vendor", "school", "parent", "super_admin"],
  },

  {
    path: "/reporting-and-analytics",
    element: <ReportingAndAnalytics />,
    roles: ["vendor", "school", "parent", "super_admin"],
  },

  {
    path: "/parent-payments-received",
    element: <ParentPaymentsReceived />,
    roles: ["school", "vendor"],
  },

  {
    path: "/payment-history",
    element: <PaymentHistory />,
    roles: ["school", "vendor"],
  },

  {
    path: "/my-payment-history",
    element: <ParentPaymentHistory />,
    roles: ["parent"],
  },

  {
    path: "/support",
    element: <Support />,
    roles: ["school", "vendor", "parent"],
  },
  // GET ALL BUS FEE FOR (ADMIN | VENDOR | SCHOOL)
  // GET ALL DRIVERS FOR (SCHOOL | VENDOR | ADMIN)
  // GET ALL PARENTS API (ADMIN | SCHOOL | VENDOR)
  // GET ALL VEHICLE API (ADMIN | SCHOOL | VENDOR)
  // GET ALL VEHICLE REGULATORY COMPLIANCE API (ADMIN | SCHOOL | VENDOR)
  // LISTING RATING & REVIEWS API (FOR SCHOOL | VENDOR | SUPER ADMIN | PARENT)
  // LISTING BUS CHARTER RESERVATION API (FOR SCHOOL | SUPER ADMIN)
  // LISTING BUSING SUBSCRIPTION RESERVATION API (FOR SCHOOL VENDOR | SUPER ADMIN)
  // LISTING BANKS API (FOR SUPER ADMIN)
  // SchoolPaymentHistory — role slug drives the data + column set (FOR SUPER ADMIN)
  {
    path: "/:slug",
    element: <SlugHandler />,
    roles: ["school", "vendor", "parent", "super_admin"],
  },
  {
    path: "/students",
    element: <AllStudents />,
    roles: ["school", "vendor"],
  },
  {
    path: "/:slug/add",
    element: <AddParentDriver />,
    roles: ["school", "vendor"],
  },
  {
    path: "/:slug/edit/:id",
    element: <EditParent />,
    roles: ["school", "vendor"],
  },
  {
    path: "/:slug/:id/students",
    element: <Studenst />,
    roles: ["school", "vendor", "super_admin"],
  },
  {
    path: "/:slug/:id/schedules",
    element: <Schedules />,
    roles: ["vendor", "school", "super_admin"],
  },
  {
    path: "/:slug/:id/schedules/add",
    element: <AddSchedule />,
    roles: ["vendor", "school"],
  },
  {
    path: "/:slug/:id/schedules/edit/:sid",
    element: <AddSchedule />,
    roles: ["vendor", "school"],
  },

  {
    path: "/:slug/book",
    element: <VendorVehicleList />,
    roles: ["school", "vendor"],
  },

  // ---- Vendor/School common Routes ----
  {
    path: "/vehicles/add",
    element: <AddVehicle />,
    roles: ["vendor", "school"],
  },
  {
    path: "/vehicles/edit/:id",
    element: <AddVehicle />,
    roles: ["vendor", "school"],
  },
  {
    path: "/route-and-schedule",
    element: <RouteSchedule />,
    roles: ["vendor", "school"],
  },
  {
    path: "/route-and-schedule/add",
    element: <AddRouteSchedule />,
    roles: ["vendor", "school"],
  },
  {
    path: "/route-and-schedule/edit/:id",
    element: <AddRouteSchedule />,
    roles: ["vendor", "school"],
  },
  {
    path: "/maintenance-and-inspection",
    element: <MaintenanceInspection />,
    roles: ["vendor", "school"],
  },
  {
    path: "/maintenance-and-inspection/add",
    element: <AddMaintenanceInspection />,
    roles: ["vendor", "school"],
  },
  {
    path: "/maintenance-and-inspection/edit/:id",
    element: <AddMaintenanceInspection />,
    roles: ["vendor", "school"],
  },
  {
    path: "/regulatory-compliance/add",
    element: <AddRegulatoryCompliances />,
    roles: ["school", "vendor"],
  },
  {
    path: "/regulatory-compliance/edit/:id",
    element: <AddRegulatoryCompliances />,
    roles: ["school", "vendor"],
  },
  {
    path: "/subscription-plans",
    element: <PricingPlan />,
    roles: ["vendor", "school"],
  },

  // ---- Vendor Routes ----

  // {
  //   path: "/vendor/seat-availability",
  //   element: <SeatAvailability />,
  //   roles: ["vendor"],
  // },
  // {
  //   path: "/vendor/seat-availability/add",
  //   element: <AddSeatAvailability />,
  //   roles: ["vendor"],
  // },
  // {
  //   path: "/vendor/seat-availability/edit/:id",
  //   element: <AddSeatAvailability />,
  //   roles: ["vendor"],
  // },

  // {
  //   path: "/:role/verification-logs",
  //   element: <VerificationLogs />,
  //   roles: ["vendor", "school"],
  // },

  // ---- School Routes ----
  {
    path: "/:slug/vendors",
    element: <Vendors />,
    roles: ["school"],
  },
  {
    path: "/bus-charter-reservations/vendors/book/:id",
    element: <VendorVehicleList />,
    roles: ["school"],
  },
  {
    path: "/payment-complete",
    element: <PaymentComplete />,
    roles: ["school", "vendor", "parent"],
  },

  // ---- Parent Routes ----
  { path: "/manage-kids", element: <Studenst />, roles: ["parent"] },
  { path: "/manage-kids/add", element: <AddKids />, roles: ["parent"] },
  {
    path: "/manage-kids/edit/:id",
    element: <AddKids />,
    roles: ["parent"],
  },
  {
    path: "/reservations",
    element: <Reservations />,
    roles: ["parent"],
  },
  {
    path: "/cancel-reservation",
    element: <CancelReservations />,
    roles: ["parent"],
  },
  {
    path: "/rides-completed",
    element: <RidesCompleted />,
    roles: ["parent"],
  },
  {
    path: "/parent-cancellations",
    element: <ParentCancellationsList />,
    roles: ["parent", "school", "vendor", "super_admin"],
  },

  // ---- Admin Routes ----
  { path: "/vendors", element: <VendorPage />, roles: ["super_admin"] },
  { path: "/schools", element: <SchoolPage />, roles: ["super_admin"] },

  {
    path: "/user-management",
    element: <VendorSchoolsPage />,
    roles: ["super_admin"],
  },
  {
    path: "/user-management/add",
    element: <UserForm />,
    roles: ["super_admin"],
  },
  {
    path: "/user-management/edit/:id",
    element: <UserForm />,
    roles: ["super_admin"],
  },

  { path: "/vehicle-make", element: <Make />, roles: ["super_admin"] },
  { path: "/vehicle-type", element: <Type />, roles: ["super_admin"] },
  { path: "/vehicle-year", element: <Year />, roles: ["super_admin"] },
  { path: "/vehicle-color", element: <Color />, roles: ["super_admin"] },
  {
    path: "/vehicle-model",
    element: <ModalPage />,
    roles: ["super_admin"],
  },
  {
    path: "/system-config",
    element: <SystemConfig />,
    roles: ["super_admin"],
  },
  {
    path: "/user-activity-logs",
    element: <UserActivityLogs />,
    roles: ["super_admin"],
  },

  {
    path: "/payment-plans",
    element: <PlansPayments />,
    roles: ["super_admin"],
  },
  {
    path: "/add-bank-detail",
    element: <AddBankDetails />,
    roles: ["super_admin"],
  },

  // ---- Manual Payment Routes (school, vendor, admin) ----
  {
    path: "/make-payment",
    element: <MakePayment />,
    roles: ["school", "vendor", "super_admin"],
  },
  {
    path: "/manual-payment-history",
    element: <ManualPaymentHistory />,
    roles: ["school", "vendor", "super_admin"],
  },
  {
    path: "/manual-payment-complete",
    element: <ManualPaymentComplete />,
    roles: ["school", "vendor", "super_admin"],
  },

  // ---- Receive Payment / External Charge Routes (school, vendor, admin) ----
  {
    path: "/receive-payment",
    element: <ReceivePayment />,
    roles: ["school", "vendor", "super_admin"],
  },
  {
    path: "/receive-payment-history",
    element: <ReceivePaymentHistory />,
    roles: ["school", "vendor", "super_admin"],
  },
  {
    path: "/receive-payment-complete",
    element: <ReceivePaymentComplete />,
    roles: ["school", "vendor", "super_admin"],
  },

  // Ride Share
    {
    path: "/rideshare/dashboard",
    element: <RideShareDashboard />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/drivers",
    element: <RideSharePlaceholder title="Drivers" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/vehicles",
    element: <RideSharePlaceholder title="Fleet / Vehicles" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/rides",
    element: <RideSharePlaceholder title="Rides" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/routes",
    element: <RideSharePlaceholder title="Routes" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/customers",
    element: <RideSharePlaceholder title="Customers" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/payment-history",
    element: <RideSharePlaceholder title="Payment History" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/driver-earnings",
    element: <RideSharePlaceholder title="Driver Earnings" />,
    roles: ["super_admin"],
  },
  {
    path: "/rideshare/analytics",
    element: <RideSharePlaceholder title="Reporting & Analytics" />,
    roles: ["super_admin"],
  },
  {
    path: "/switch-project",
    element: <SwitchProject />,
    roles: ["super_admin"],
  },
  // 

  // ---- 404 ----
  { path: "*", element: <_404 />, roles: null },
];
